export default __webpack_public_path__ + "static/install-0082266ea075e4c1cd137111859cdd8f.png";